module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it-166b8c7b6c72c2e75d6ab7b8d3d6c203.jpg";